<template>
  <div>
    <div class="bg-section">
      <v-col
        lg="5"
        sm="10"
      >
        <br>
        <br>
        <br>
        <v-card
          color="#FFFFFF"
          class="elevation-10 outter-section"
        >
          <v-card-text>
            <v-col
              lg="10"
              md="12"
              sm="12"
            >
              <div class="pl-10 pt-10 pb-10 pr-10">
                <img
                  width="100px"
                  src="../../../../assets/img/swift-checkin-ezybuild-logo.png"
                  alt
                >
                <br>
                <div class="pt-10">
                  <h1>
                    Check-out
                  </h1>
                  <br>
                  <div
                    v-if="appUserCheckInRecord && appUserCheckInRecord.app_user && appUserCheckInRecord.project"
                    class="check-in-details-style"
                  >
                    <p>
                      <font class="company-text-style">
                        {{ appUserCheckInRecord.app_user.organization.name }}
                      </font>
                    </p>
                    <p class="title-text-style">
                      Project: <font class="value-text-style">
                        {{ appUserCheckInRecord.project.name }}
                      </font>
                    </p>
                    <p class="title-text-style">
                      Check-in Time: <font class="value-text-style">
                        {{ appUserCheckInRecord.checkin_time | convertToLocal }}
                      </font>
                    </p>
                  </div>
                  <br>
                  <div class="worker-clock">
                    <p>Worker Clock</p>
                    <span class="timer-style mr-3">
                      <check-in-clock />
                    </span>
                  </div>
                  <br>
                </div>
                <div class="button-group">
                  <v-btn
                    class="cost-shift-btn"
                    :disabled="isCheckInFromApp"
                    @click="confirmCostShiftType()"
                  >
                    cost-shift
                  </v-btn>
                  <v-btn
                    class="checkout-btn"
                    @click="showCheckOutAlert = true"
                  >
                    check-out
                  </v-btn>
                </div>
              </div>
            </v-col>
          </v-card-text>
        </v-card>
        <br>
        <br>
        <br>
      </v-col>
    </div>
    <centre-spinner :loading="loading" />
    <issue-status
      v-if="showIssueStatus"
      @cancel="showIssueStatus = false"
    />
    <alert-dialog
      v-if="showCostShiftAlert"
      :title="'Confirm'"
      :message="'The cost shift was performed on the same project. Are you sure you will continue?'"
      @closed="showCostShiftAlert = false"
      @confirmed="toCostShift()"
    />
    <alert-dialog
      v-if="showCheckOutAlert"
      :title="'Confirm'"
      :message="'Are you sure you want to checkout ?'"
      @closed="showCheckOutAlert = false"
      @confirmed="confirmCheckOut()"
    />
  </div>
</template>

<script>
import spinner from '../../../components/SpinnerCentre.vue';
import AlertDialog from '../dialogs/AlertDialog.vue';
import IssueStatus from '../dialogs/IssueStatus.vue';
import CheckInClock from './CheckInClock.vue';
import Constants from 'src/constants';
import moment from 'moment';

export default {
  name: 'CheckOutCostShiftPage',
  components: {
    'centre-spinner': spinner,
    'alert-dialog': AlertDialog,
    'check-in-clock': CheckInClock,
    'issue-status': IssueStatus,
    },
  filters: {
    convertToLocal (stringDatetime) {
      return moment(stringDatetime).local().format('YYYY-MM-DD hh:mm A');
    },
  },
  data () {
    return {
      loading: false,
      picker: null,
      showCostShiftAlert: false,
      showIssueStatus: false,
      user: {},
      showCheckOutAlert: false,
    };
  },
  computed: {
    appUserCheckInRecord () {
      return this.$store.getters['devices/getActiveCheckInDetails'];
    },
    getWorker () {
       return this.$store.getters.getWorker;
      },
      deviceData () {
      return this.$store.getters.getDeviceData;
    },
    isCheckInFromApp () {
      if (this.appUserCheckInRecord.checkin_kiosk === null) {
        return true;
      }
       return false;
    },
  },
  mounted () {
    this.loading = true;
    this.checkUserExist();
    this.loading = false;
  },
  methods: {
    async checkUserExist () {
      this.user = localStorage.getItem('worker');
      if (this.user === null) {
        this.$router.push({ name: 'DeviceCheckInCheckOut' });
        return;
      }
      await this.getCheckInRecords();
      },
    async toCostShift () {
      this.loading = true;
      this.showCostShiftAlert = false;
      this.$store.dispatch('devices/saveCheckOutMethod', 'cost-shift');
      setTimeout(() => {
        this.$router.push({ name: 'CostShift' });
      }, 1000);
    },
    confirmCostShiftType () {
        this.showCostShiftAlert = true;
    },
    async confirmCheckOut () {
        if (this.appUserCheckInRecord.work_details.type === 'project-issue') {
        this.showIssueStatus = true;
        return;
      }
      await this.$store.dispatch('devices/checkOutUser', {
            checkOutTime: {
              checkout_time: moment.utc().format(),
              type: 'manual-onsite',
              checkout_kiosk_id: this.deviceData.id,
            },
            checkInId: this.appUserCheckInRecord.id,
          }).then(() => {
            this.$store.dispatch('alert/onAlert', {
            message: 'Check-out completed successfully.',
            type: Constants.ALERT_TYPE_SUCCESS,
          });
          });
          await this.$store.dispatch('devices/workerLogout');
          await this.$store.dispatch('kioskUserLogout');
          this.loading = false;
          await this.$router.push({ name: 'DeviceCheckInCheckOut' });
        },
        async getCheckInRecords () {
      try {
        await this.$store.dispatch('devices/fetchUsersCurrentCheckInDetails');
      } catch (error) {
        await this.$router.push({ name: 'DeviceCheckInCheckOut' });
      }
    },
      },
  };

</script>

<style scoped>
.bg-section::-webkit-scrollbar {
  display: none;
}

.checkin-btn {
  border-radius: 100px;
}

.checkout-btn {
  border-radius: 100px;
}

.clock-style {
  position: relative;
  width: 100%;
  margin-top: 20px;
  padding: 20px 40px;
  background: #37474f;
  border-radius: 20px;
  height: 200px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.clock-style:before {
  position: absolute;
  content: "";
  height: 300px;
  width: 100px;
  top: -25px;
  left: -50px;
  transform: rotate(-15deg);
  background: #52616a;
  z-index: 1;
}

.clock-style:after {
  position: absolute;
  content: "";
  height: 300px;
  width: 100px;
  top: -25px;
  left: -30px;
  transform: rotate(15deg);
  background: #46545b;
}

.logo-style {
  width: 100%;
  height: 100%;
  border: 1px solid grey;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.clock-color {
  z-index: 2;
  color: white;
}

.v-card__text {
  padding: 0px;
}
.cost-shift-btn {
  border-radius: 100px;
}
.bg-image {
  background-image: url("../../../../assets/img/welcome-bg.jpg");
  background-size: cover;
  background-position: center;
}

@media (max-width: 900px) {
  .bg-image {
    display: none;
  }

  .cost-shift-btn {
  border-radius: 100px;
  width: 200px;
  height: 50px !important;
}
.checkout-btn {
  border-radius: 100px;
  width: 200px;
  height: 50px !important;
}

  .logo-style {
    width: 100%;
    height: 100%;
    border: 1px solid grey;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .clock-color {
    font-size: 25px;
  }
}

  .v-card {
    background: rgba(255, 255, 255, 0.582);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border: 2px solid rgba(255, 255, 255, 0.445);
  }

  .v-card__text {
    padding: 0px;
  }

  .inner-section {
    z-index: 5;
  }

  .outter-section {
    position: relative;
    overflow: hidden;
    z-index: 1;
  }

  .outter-section:before {
    z-index: -1;
    position: absolute;
    content: '';
    right: -80px;
    top: -100px;
    width: 200px;
    height: 1000px;
    transform: rotate(10deg);
    background: #ececec;
  }

  .outter-section:after {
    z-index: -1;
    position: absolute;
    content: '';
    right: -100px;
    top: -80px;
    width: 250px;
    height: 1000px;
    transform: rotate(30deg);
    background: #F8F8F8;
  }

  .button-group {
    display: flex;
    gap: 20px;
  }

  .check-in-details-style {
    padding: 20px 20px;
    border-radius: 10px;
    background: #F9F9F9;
  }

  .company-text-style {
    background: rgb(255,166,0);
    background: linear-gradient(295deg, rgb(255, 123, 0) 0%, rgba(255,55,0,1) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: larger;
    font-weight: bold;
  }

  .worker-clock {
    border-radius: 10px;
    border: 1px solid #37474F;
    padding: 40px 40px;
    background: #ffffff;
  }
  .v-btn.theme--dark.v-btn--disabled.v-btn--has-bg {
  background: rgb(202, 202, 202) !important;
}
  </style>
